import styled from 'styled-components';

export default styled.div`
	--size: var(--px-8);
	--left: calc(var(--size) + var(--spacing-small));
	display: flex;
	flex-direction: column;
	gap: 0;
	position: relative;
	padding-left: var(--left);

	&:before {
		content: '';
		position: absolute;
		width: var(--size);
		height: var(--size);
		border-radius: 50%;
		background: ${({$color}) => $color};
		left: 0;
		top: var(--spacing-medium-small);
		transform: translateY(-50%);
	}

	.grey {
		color: var(--neutrals-700);
	}
	.red {
		color: var(--red-600);
	}
`;
